import React from "react";

import { NiceMemberBlock } from "../pages/parameters/Organisation";

const ListView = ({
  users,
  removable,
  setMemberOpen,
  canopen,
  show_id = false,
}) => {
  return (
    <div className="bg-white w-full">
      {/* Map through users and render ListCell for each */}
      {users
        .sort((a, b) => {
          if (a.org_admin === b.org_admin) {
            return a.role?.localeCompare(b.role);
          }
          return b.org_admin - a.org_admin;
        })
        .map((user, index) => (
          <div key={index}>
            <NiceMemberBlock
              last={index === users.length - 1}
              user={user}
              setMemberOpen={setMemberOpen}
              canopen={canopen}
              show_id={show_id}
            ></NiceMemberBlock>
          </div>
        ))}
    </div>
  );
};

export default ListView;
